module.exports = __webpack_public_path__ + "img/newspaper4_nohead.4e30d91f.png";